export default (props) => {
  if (!props.error) return;
  return (
    <div className="alert alert-danger alert-dismissible align-items-center fade show">
      {props.text}
      {props.error && props.error.message
        ? <span> {props.error.message}</span>
        : null
      }
    </div>
  );
};
